module.exports = __webpack_public_path__ + "img/ksish.78a5f01a.png";